<template>
    <MainComponent :id="anchorsPageProfile.aboutSection">
        <template #title>
            <h2>{{ sectionTitle }}</h2>
        </template>
        <template #title-action>
            <LazyAboutTranslation />
        </template>
        <template #content>
            <AboutSectionCommon />
        </template>
    </MainComponent>
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {LazyAboutTranslation} from '#components';
    import {useTranslation} from '#imports';
    import MainComponent from '~/components/main/common/MainComponent.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import AboutSectionCommon from '~/features/about/ui/AboutSectionCommon.vue';
    import {useProfileStore} from '~/store/profileStore';

    const {profile} = storeToRefs(useProfileStore());

    const {t} = useTranslation();

    const sectionTitle = computed(() => t('profile.section.about.title', {0: profile.value?.firstname}));
</script>
